/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from "@glimmer/component";
import { getJesOfClass } from "parog-web/utils/journal-events";
import { sortBy } from "parog-web/utils/sort";
import type JesHistoryTableComponent from "..";
import type JesHistoryTableColumnComponent from "../column";

interface Signature {
  Args: {
    table: JesHistoryTableComponent;
    column: JesHistoryTableColumnComponent;
    date: Date;
  };
}

export default class JesHistoryTableCellComponent extends Component<Signature> {
  get patient() {
    return this.args.table.args.patient;
  }

  get jes() {
    let jes;
    try {
      jes = this.patient
        .get(this.args.column.patientRelationName)
        // This filter should probably be done elsewhere, maybe on the patient as we have `journalEvents` & `activeJournalEvents` or we can consider that all fetched JE are not archived ?
        .filter(je => !je.isArchived)
        .sort(sortBy("occurredAt", "desc"));
    } catch {
      jes = getJesOfClass(
        this.patient.activeJournalEvents,
        this.args.column.jeClass
      );
    }

    return jes.filter(je => {
      return +je.occurredOn === +this.args.date;
    });
  }
}
